export const ORDER_PAYMENT_DETAILS_TEST_ID = 'order-payment-details-test-id';
